import "../css/Contact.css";
import { FaGithub, FaLinkedin, FaEnvelope } from "react-icons/fa";

export const Contact = () => {
  return (
    <section>
     
      <div className="connect-container">
          <div className="connect-details-container">
          <p><code>solveiga.g@outlook.com</code></p>
          <p><code> 44 (0) 7759807749 </code></p>
          <p><code> Greater Manchester Area, United Kingdom</code></p>
          </div>
        <div className="connect-icons-container">
          <a href="mailto:solveiga.g@outlook.com"><FaEnvelope className="icon" /></a>

          <a href="https://www.linkedin.com/in/solveigag/" target="_blank" rel="noreferrer"><FaLinkedin className="icon" /></a>

          <a href="https://github.com/solveigag" target="_blank" rel="noreferrer"><FaGithub className="icon" /></a>
        </div>
      </div>
    </section>
  );
};
